export default __webpack_public_path__ + "static/kfm-company-logo-1af2a3868f869e703cd3dcd4e060b273.svg";